import TeamMemberItem from "./team-member-item";

export default function TeamMemberList(props)
{
    const { className, items } = props;

    if ( !items || !items.length ) {
        return "";
    }

    const teamMemberItems = items.map((item, index) => (
        <TeamMemberItem
            key={ index }
            className="border-b-3 border-b-grey last:border-b-0 py-40 first:pt-0 last:pb-0"
            firstName={ item.firstName ?? "" }
            lastName={ item.lastName ?? "" }
            title={ item.title ?? "" }
            bio={ item.bio ?? "" }
            image={ item.image ?? "" }
        />
    ));

    return (
        <div className={ "" + (className ? " " + className : "") }>
            { teamMemberItems }
        </div>
    )
}